export default __webpack_public_path__ + "static/media/vlf_cropped.e887c01a.png";